import styles from "./Filters.module.css";

interface Props {
	onChange: (v: string) => void;
	selected: string;
}

export default function SportFilter({ onChange, selected }: Props) {
	return (
		<div className={styles.sportFilter}>
			<select onChange={(e) => onChange(e.target.value)} value={selected}>
				<option className={styles.option} value={""}>
					All Sports
				</option>
				<option className={styles.option} value={"16"}>
					Baseball
				</option>
				<option className={styles.option} value={"23"}>
					Football
				</option>
				<option className={styles.option} value={"24"}>
					Soccer
				</option>
				<option className={styles.option} value={"17"}>
					Softball
				</option>
				<option className={styles.option} value={"15"}>
					Basketball
				</option>
			</select>
		</div>
	);
}
